<template>
  <v-app id="inspire" style="background-color:#0a252c">
    <v-content>
      <v-container class="fill-height" fluid color="red">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {};
</script>